import { useMutation } from '@tanstack/react-query';

import { BulkCategoryRow, bulkUpdateCategories } from '~/services/ExperiencesService';

export function useBulkUpdateCategories() {
  return useMutation({
    mutationFn: (rows: BulkCategoryRow[]) => bulkUpdateCategories(rows),
  });
}
